var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector41(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 402,
    viewBox: "0 0 197 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.852 400.661C170.999 374.129 167.247 368.582 152.737 342.885C149.182 336.589 143.882 324.574 139.25 309.999C137.861 305.637 136.65 301.335 135.578 297.11C127.949 266.879 130.763 234.59 137.857 203.3C155.961 123.466 122.356 44.4753 59.0965 14.0223C-4.28208 -16.4935 -82.7879 8.30569 -126.318 57.9736C-131.982 64.4363 -157.269 95.133 -165.432 131.532C-191.238 246.45 -85.0723 308.548 81.3974 367.521C84.6361 368.666 100.145 373.472 103.448 374.406L195.863 400.663L195.852 400.661Z",
    stroke: "#E1E3E9",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector41);
export default __webpack_public_path__ + "static/media/vector4-1.b8783598d3639025dec06fbfa92d76de.svg";
export { ForwardRef as ReactComponent };